var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.artefactsList, function(item, index) {
        return _c("div", { key: index }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-8" },
              [
                _c("artefact-select", {
                  attrs: {
                    "selected-artefact-type": item.artefactType,
                    "selected-artefact": item.artefact,
                    "create-hidden-input": _vm.createHiddenInput,
                    "artefact-type-input-name":
                      _vm.artefactTypeInputName + "[]",
                    "artefact-input-name": _vm.artefactInputName + "[]",
                    index: index
                  },
                  on: { "update-artefact": _vm.updateArtefact }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-1 pull-center" }, [
              _c(
                "span",
                {
                  staticClass: "btn btn-fill btn-github",
                  on: {
                    click: function($event) {
                      return _vm.remove(index)
                    }
                  }
                },
                [
                  _vm._v("Kaldır "),
                  _c("i", { staticClass: "fa fa-times-circle" })
                ]
              )
            ])
          ])
        ])
      }),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "btn btn-fill btn-twitter", on: { click: _vm.add } },
        [_vm._v("\n        Ekle\n    ")]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a0bfd71", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a0bfd71","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/vue/artefact-select-list.vue
// module id = 58
// module chunks = 0